import { Link, useLocation } from 'react-router-dom';

const SPORTS = [
  { key: 'americanfootball_nfl', label: 'NFL' },
  { key: 'americanfootball_ncaaf', label: 'NCAAF' },
  { key: 'basketball_nba', label: 'NBA' },
  { key: 'basketball_ncaab', label: 'NCAAB' },
  { key: 'baseball_mlb', label: 'MLB' },
  { key: 'icehockey_nhl', label: 'NHL' },
  { key: 'soccer_usa_mls', label: 'MLS' },
  { key: 'mma_mixed_martial_arts', label: 'MMA' },
  { key: 'boxing_boxing', label: 'Boxing' },
  { key: 'golf', label: 'Golf' },
];

export default function Navbar({ sport, setSport, sidebarCollapsed, darkMode, setDarkMode, favoriteSports = [] }) {
  const location = useLocation();
  const favSet = new Set(favoriteSports);

  return (
    <nav className={`fixed top-0 right-0 z-50 h-12 border-b border-[#E5E7EB] dark:border-[#1e2536] bg-white/80 dark:bg-[#0a0d14]/90 backdrop-blur-sm transition-all duration-200 ${sidebarCollapsed ? 'left-0 lg:left-[68px]' : 'left-0 lg:left-[180px]'}`}>
      <div className="h-full flex items-end pl-12 lg:pl-5 pr-2 overflow-x-auto">
        {/* Sport tabs — text-style with bottom border */}
        <div className="flex-1 min-w-0 flex items-end overflow-x-auto">
        {SPORTS.map((s) => {
          const active = sport === s.key && location.pathname === '/';
          const isFav = favSet.has(s.key);
          return (
            <Link
              key={s.key}
              to="/"
              onClick={() => setSport(s.key)}
              className={`relative px-0 mr-6 pb-[10px] text-[14px] whitespace-nowrap transition-colors duration-150 border-b-2 ${
                active
                  ? 'font-semibold text-[#111827] dark:text-[#e2e8f0] border-[#005BB3] dark:border-[#3b82f6]'
                  : 'font-medium text-[#6B7280] dark:text-[#8892a8] border-transparent hover:text-[#4B5563] dark:hover:text-[#e2e8f0]'
              }`}
              style={{ fontFamily: 'var(--font-sans)' }}
            >
              {s.label}
              {isFav && <span className="absolute -top-0.5 -right-1.5 w-[5px] h-[5px] rounded-full bg-[#005BB3] dark:bg-[#3b82f6]" />}
            </Link>
          );
        })}
        </div>

        {/* Dark mode toggle */}
        <button
          onClick={() => setDarkMode((d) => !d)}
          className="flex-shrink-0 mb-2 ml-3 p-1.5 rounded text-[#6B7280] dark:text-[#8892a8] hover:text-[#111827] dark:hover:text-[#e2e8f0] hover:bg-[#f1f5f9] dark:hover:bg-[#151a25] transition-colors duration-150"
          aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {darkMode ? (
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          ) : (
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
            </svg>
          )}
        </button>
      </div>
    </nav>
  );
}
